import Cookies from 'js-cookie';
import moment from 'moment';

export const shouldDisplayAdditionalPurchaseConfirmationModal = (
  userId?: number,
  eventId?: string
) => {
  const { last_purchased_at, last_purchased_event_id, last_purchased_user_id } =
    Cookies.get();
  const timeNow = moment();
  const lastPurchaseWasLessThanTwoMinutesAgo =
    timeNow.diff(last_purchased_at, 'seconds') <= 120;
  const isLastPurchaseUser = userId?.toString() === last_purchased_user_id;
  const isLastPurchaseEvent = eventId?.toString() === last_purchased_event_id;

  return (
    lastPurchaseWasLessThanTwoMinutesAgo &&
    isLastPurchaseUser &&
    isLastPurchaseEvent
  );
};
